//GeneratorFlag:[NoChange]
import Province from './province';

export default {Province}
export{Province}